import { Grid2 } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import React, { Component } from "react";
import EnhancedTable from "./AdvTable";
import { FilmCard } from "./commonComponents";

const styles = (theme) => ({
    button: {
        marginRight: theme.spacing(1),
    },
});

class AdvertisingTable extends Component {
    handleDeleteChip() {}

    render() {
        return (
            (<Grid2 container spacing={1}>
                <Grid2 size={12}>
                    <FilmCard />
                </Grid2>
                <Grid2 size={12}>
                    <EnhancedTable />
                </Grid2>
            </Grid2>)
        );
    }
}

export default withStyles(styles)(AdvertisingTable);
